import * as React from "react"

const Textarea = React.forwardRef(({ className = "", ...props }, ref) => {
    const baseClasses =
        "flex min-h-[80px] w-full rounded-md border  text-sm  focus-visible:outline-none focus-visible:ring-2  focus-visible:ring-orange-500  disabled:cursor-not-allowed"

    return (
        <textarea
            ref={ref}
            className={`${baseClasses} ${className}`}
            {...props}
        />
    )
})

Textarea.displayName = "Textarea"

export { Textarea }
